import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  currencyFormat,
  convertStringToInteger
} from 'common/helpers/numberHelper';
// eslint-disable-next-line import/no-cycle
import LoginModal from 'profile/login/LoginModal';
import { addCartItem } from 'redux/cart/actions';

const NoCustomer = (props) => {
  const { product } = props;
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modal, setModal] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [errorMessage, setErrorMessage] = useState(null);

  const settings = useSelector((state) => state.setting);
  const { price, sku } = product.variants[0];
  const pricingArray = product.loyalty?.pricing || [];

  const handleLogin = () => {
    setModal('Login');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (quantity === '' || Number.isNaN(quantity)) {
      setIsSubmitting(false);
      setErrorMessage('Invalid Quantity');
      return;
    }
    const qty = convertStringToInteger(quantity);
    if (qty < 1) {
      setIsSubmitting(false);
      setErrorMessage('Invalid Quantity');
      return;
    }
    const analytics = {
      viewType: 'Loyalty Widget'
    };

    const item = {
      quantity: qty,
      sku
    };
    dispatch(addCartItem(item, analytics));
  };

  const handleQuantity = (e) => {
    const input = e.target.value;
    const qty = input.replace(/[^0-9]/g, '');
    setQuantity(qty);
    setErrorMessage(null);
    setIsSubmitting(false);
  };

  return (
    <>
      {pricingArray.length > 0 && (
        <div className="widget-pricing-nocustomer">
          <button type="button" onClick={handleLogin} className="c7-button">
            Member Login
          </button>
          <LoginModal modal={modal} setModal={setModal} />
        </div>
      )}
      <div className="widget-pricing-add-to-cart">
        <form onSubmit={handleSubmit}>
          {errorMessage && (
            <div className="c7-product__error" aria-describedby="qtyerror">
              Error: {errorMessage}
            </div>
          )}
          <div className="widget-pricing-add-to-cart-without-points">
            <input type="text" value={quantity} onChange={handleQuantity} />
            <span>@</span> {currencyFormat(price, settings)}
          </div>
          <button type="submit" className="c7-button" disabled={isSubmitting}>
            Add To Cart
          </button>
        </form>
      </div>
    </>
  );
};

export default NoCustomer;
